import React, { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import moment from "jalali-moment";
import { useMutation } from "@tanstack/react-query";
import { cancelModifiedArticleUpdate } from "../../../../service/api";
import { wordpressArticlesUiHelper } from "../../../../helpers/wordpressUiHelper";
import { Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

function ExpertArticlesSwiper({ article }) {
  const navigate = useNavigate();
  const [articleData, setArticleData] = useState(null);

  useEffect(() => {
    setArticleData(wordpressArticlesUiHelper(article));
  }, [article]);

  const cancelUpdateMutation = useMutation(cancelModifiedArticleUpdate, {
    // onSuccess: () => {
    //   return queryCilent.invalidateQueries({
    //     queryKey: ["contents"],
    //   });
    // },
  });

  const cancelUpdate = () => cancelUpdateMutation.mutate(article?.id);

  return (
    <div className="w-full max-lg:w-full relative h-fit max-lg:h-full p-2  bg-gray-100 rounded-[10px] flex-col justify-start items-center gap-3.5 inline-flex font-body">
      <div className="bg-slate-200 rounded-[10px] flex-col justify-center items-center gap-2.5 flex">
        <img
          className="w-[280px] h-[156px] rounded-[9px]"
          src={articleData?.featuredImage}
          alt="article"
        />
      </div>
      <div className="justify-center items-center gap-3 inline-flex">
        <div className="w-[280px] max-lg:w-full whitespace-nowrap overflow-hidden text-ellipsis text-right text-neutral-600 text-2xl max-lg:text-lg font-medium">
          <p className="w-[280px] max-lg:w-full px-1 whitespace-nowrap text-lg font-bold overflow-hidden text-ellipsis ">
            {articleData?.title}
          </p>
        </div>
      </div>
      <div className="w-[280px] max-lg:w-full  whitespace-nowrap overflow-hidden text-ellipsis text-neutral-600 text-[13px] font-medium">
        <div className="w-[280px] max-lg:w-full px-1 whitespace-nowrap overflow-hidden text-ellipsis">
          {articleData?.content.replace(/(<([^>]+)>)/gi, "")}
        </div>
      </div>
      <div className="w-full justify-between  items-center gap-[67px] inline-flex">
        <div className=" py-2  bg-zinc-200 gap-0 rounded-xl items-center flex justify-evenly">
          <div className="w-[70px] gap-0 m-auto h-[19px] max-lg:w-16  max-lg:text-xs text-center text-zinc-500 text-xs font-medium">
            {articleData?.date &&
              moment(articleData?.date, "YYYY/MM/DD")
                .locale("fa")
                .format("YYYY/MM/DD")}
          </div>
          <div className="text-center text-black text-[10px]  font-black tracking-tight">
            {articleData?.data?.categories?.map((cat) => cat?.persianName)}
          </div>
        </div>
        {/* action buttons */}
        <div className="w-full justify-between absolute flex bottom-2 left-0 px-2 z-40">
          {/* edit */}
          {articleData?.showEditBtn && (
            <Button
              className=" text-xs  mr-auto"
              icon={<EditOutlined />}
              onClick={() =>
                navigate(`article/${articleData?.id}`, {
                  state: {
                    articleData: JSON.stringify(articleData),
                  },
                })
              }
            >
              ویرایش محتوا
            </Button>
          )}
        </div>
      </div>
      {/* info texts */}
      {articleData?.showMaskLayer && (
        <div className="flex w-full flex-col max-lg:justify-center justify-start py-10 gap-3 bg-slate-200/80 absolute top-0 left-0 bottom-0 font-body rounded-xl z-30">
          {/* main info */}
          <p className="text-lg font-bold text-black">
            {articleData?.mainInfoText}
          </p>

          {/* detail info */}
          <p className="text-sm font-bold text-black">
            {articleData?.detailInfoText}
          </p>
        </div>
      )}
    </div>
  );
}

export default ExpertArticlesSwiper;
